
<template>
    <!-- MAIN SLIDER -->
	<section id="main-slider" class="main-slider">
		<div class="inner">
			<!-- Slide One -->
			<div class="slide slide1" style="background-image: url(/src/assets/img/Slide01.jpg);">
				<div class="container">
					<div class="slide-inner1 common-inner">
						<span style="text-align:right; letter-spacing:4px; font-family: 'Playfair Display', serif; font-style: normal; font-weight: 31; text-transform: initial;text-shadow: 0.1em 0.1em 0.2em black" class="h1"  data-animation="drop" data-delay="0.5s">Somos especialistas</span>
						 <span style="text-align:right;letter-spacing:3px; font-size: 40px; font-family: 'Playfair Display', serif; font-style: normal; font-weight: 31; text-transform: initial;text-shadow: 0.1em 0.1em 0.2em black" class="h1"  data-animation="drop" data-delay="0.5s">
						 en grandes soluciones</span><br>
					</div>
				</div>
			</div>
			<!-- Slide two -->
			<div class="slide slide2" style="background-image: url(/src/assets/img/Slide02.jpg);">
				<div class="container">
					<div class="slide-inner2 common-inner">
						<span style="text-align:right; letter-spacing:4px; font-family: 'Playfair Display', serif; font-style: normal; font-weight: 31; text-transform: initial;text-shadow: 0.1em 0.1em 0.2em black" class="h1"  data-animation="drop" data-delay="0.5s">Cobertura Nacional e Internacional</span>
					</div>
				</div>
			</div>
			<!-- Slide three -->
			<div class="slide slide3" style="background-image: url(/src/assets/img/Slide03.jpg);">
				<div class="container">
					<div class="slide-inner3 common-inner">
						<span style="text-align:right; letter-spacing:4px; font-family: 'Playfair Display', serif; font-style: normal; font-weight: 31; text-transform: initial;text-shadow: 0.1em 0.1em 0.2em black" class="h1"  data-animation="drop" data-delay="0.5s">Desarrollo, ejecucion, promocion de campañas</span>
					</div>
				</div>
			</div>
		</div>
	</section><!-- MAIN SLIDER END-->
</template>

<script>
export default {
  name: 'MainHeader',
}

</script>


// WEBPACK FOOTER //
// src/components/header/MainHeader.vue